
export default function (sdkClient, sdkConfig, contentId) {
  sdkClient, sdkConfig, contentId
  sdkClient.getContentById(contentId, {tracking: 0}).then(function(response){
    window.open(`${sdkConfig.helpsiteURL.replace(/\/$/, '')}/content/${response.data.results[0].slug}/?o=gp`,'_blank');
  });
};



// WEBPACK FOOTER //
// ./src/scripts/helpers/open-helpcenter-content.js